export default {
	allTeams(state) {
		return state.teams;
	},
	getLineUps(state) {
		return state.lineUps
	}
};
